import {BrowserModule, DomSanitizer} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {ExcSigninUiModule} from 'exc-signin-ui';
import {AppRoutingModule, StateSecurityProcessor} from './app-routing.module';
import {AppComponent, HtmlContentPipe} from './app.component';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map, mergeMap} from 'rxjs/operators';
import {environment} from '../environments/environment';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {ExcControlsModule} from 'exc-controls';
import {ExcTabModule} from 'exc-tab';
import {ExcSigninModule} from 'exc-signin';
import {ExcRestModule} from 'exc-rest';
import {ToastModule} from 'primeng/toast';
import {InputTextModule, OverlayPanelModule, TooltipModule} from 'primeng/primeng';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ExcMapModule} from 'exc-map';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ScConfigComponent} from './config/selfcheck/sc-config/sc-config.component';
/*import {SimplePdfViewerModule} from 'simple-pdf-viewer';*/
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {CommonModule, CurrencyPipe, DatePipe, registerLocaleData} from '@angular/common';

import {OrderOpenComponent} from './order-open/order-open.component';
import {OrderFinishedComponent} from './order-finished/order-finished.component';
import {OrderDetailsComponent} from './order-details/order-details.component';
import {AppExcChartComponent} from './app-exc-chart/app-exc-chart.component';
import {AppExcProgbarComponent} from './app-exc-progbar/app-exc-progbar.component';
import {ModalInfoMailComponent} from './modals/modal-info-mail/modal-info-mail.component';
import {AppExcIndicatorComponent} from './app-exc-indicator/app-exc-indicator.component';
import {AppExcGayNumberComponent} from './app-exc-gay-number/app-exc-gay-number.component';
import {OrderCreateComponent} from './order-create/order-create.component';
import {PlanningHqComponent} from './planning-hq/planning-hq.component';
import {SearchSlimComponent} from './search-slim/search-slim.component';
import {DealerListComponent} from './dealer-list/dealer-list.component';
import {DealerDetailsComponent} from './dealer-details/dealer-details.component';
import {AuditItemSmallComponent} from './audit-item-small/audit-item-small.component';
import {HistoryItemSmallComponent} from './history-item-small/history-item-small.component';
import {AuditRecentComponent} from './audit-recent/audit-recent.component';
import {ModalNewAuditComponent} from './modals/modal-new-audit/modal-new-audit.component';
import {ModalDealerEditComponent} from './modals/modal-dealer-edit/modal-dealer-edit.component';
import {ModalPlanningHqHelpComponent} from './modals/modal-planning-hq-help/modal-planning-hq-help.component';
import {ModalPlanningHqWarningComponent} from './modals/modal-planning-hq-warning/modal-planning-hq-warning.component';
import {AuditDetailsComponent} from './audit-details/audit-details.component';
import {AuditScoreComponent} from './audit-score/audit-score.component';
import {PlanningHq2Component} from './planning-hq2/planning-hq2.component';
import {
  ModalPlanningHqApprovalComponent
} from './modals/modal-planning-hq-approval/modal-planning-hq-approval.component';
import {
  ModalPlanningHqAuditDetailComponent
} from './modals/modal-planning-hq-audit-detail/modal-planning-hq-audit-detail.component';
import {InventoryItemSmallComponent} from './inventory-item-small/inventory-item-small.component';
import {AuditWaffleComponent} from './waffles/audit-waffle/audit-waffle.component';
import {InventoryWaffleComponent} from './waffles/inventory-waffle/inventory-waffle.component';
import {InventoryResultWaffleComponent} from './waffles/inventory-result-waffle/inventory-result-waffle.component';
import {DealerWaffleComponent} from './waffles/dealer-waffle/dealer-waffle.component';
import {MandantWaffleComponent} from './waffles/mandant-waffle/mandant-waffle.component';
import {ResultWaffleComponent} from './waffles/result-waffle/result-waffle.component';
import {InventoryDetailsComponent} from './inventory-details/inventory-details.component';
import {
  ModalPlanningHqSettingsComponent
} from './modals/modal-planning-hq-settings/modal-planning-hq-settings.component';
import {KanbanComponent} from './kanban/kanban.component';
import {KanbanItemComponent} from './kanban-item/kanban-item.component';
import {ModalKanbanResetPinComponent} from './modals/modal-kanban-reset-pin/modal-kanban-reset-pin.component';
import {ModalKanbanResendCodeComponent} from './modals/modal-kanban-resend-code/modal-kanban-resend-code.component';
import {ModalAuditCancelComponent} from './modals/modal-audit-cancel/modal-audit-cancel.component';
import {ModalYesNoComponent} from './modals/modal-yes-no/modal-yes-no.component';
import {ModalAuditPinChangedComponent} from './modals/modal-audit-pin-changed/modal-audit-pin-changed.component';
import {ModalAuditExtendComponent} from './modals/modal-audit-extend/modal-audit-extend.component';
import {ModalCommentComponent} from './modals/modal-comment/modal-comment.component';
import {ModalResendCodeComponent} from './modals/modal-resend-code/modal-resend-code.component';
import {SliderComponent} from './app-exc-slider/slider.component';
import {SliderControlsComponent} from './app-exc-slider/slider-controls/slider-controls.component';
import {ChartSliderComponent} from './chart-slider/chart-slider.component';
import {SliderElementDirective} from './app-exc-slider/slider-element.directive';
import {SingleChartComponent} from './chart-slider/singleChart/single-chart.component';
import {CommentWaffleComponent} from './waffles/comment-waffle/comment-waffle.component';
import {ExcAttachmentsComponent} from './attachments/exc-attachments/exc-attachments.component';
import {ExcFileInputComponent} from './attachments/exc-file-input/exc-file-input.component';
import {ExcUploadDialogComponent} from './attachments/exc-upload-dialog/exc-upload-dialog.component';
import {ExcUploadRequiredValidator} from './attachments/validators/exc-upload-required.validator';
import {ExcUploadDirective} from './attachments/directives/exc-upload.directive';
import {ExcDirectUploadDirective} from './attachments/directives/exc-direct-upload.directive';
import {AuditReviewComponent} from './audit-review/audit-review.component';
import {ReviewListOpenComponent} from './review-list-open/review-list-open';
import {ReviewListOpenItemComponent} from './review-list-open-item/review-list-open-item.component';
import {ModalAssignReviewsComponent} from './modals/modal-assign-reviews/modal-assign-reviews.component';
import {AttachmentViewerComponent} from './attachment-viewer/attachment-viewer.component';
import {DataImportComponent} from './data-import/data-import.component';
import {DataImportEditMailModalComponent} from './data-import-edit-mail-modal/data-import-edit-mail-modal.component';
import {ReviewInboxComponent} from './review-inbox/review-inbox.component';
import {
  DataImportUploadConfirmModalComponent
} from './data-import-upload-confirm-modal/data-import-upload-confirm-modal.component';
import {ModalReviewFinsihComponent} from './modals/modal-review-finsih/modal-review-finsih.component';
import {DefaultableInputComponent} from './defaultable-input/defaultable-input.component';
import {ClientConfigComponent} from './client-config/client-config.component';
import {ConfigComponent} from './config/config.component';
import {ModalReviewBatchEditComponent} from './modals/modal-review-batch-edit/modal-review-batch-edit.component';
import {AuditLandingStripComponent} from './audit-landing-strip/audit-landing-strip.component';
import {AuditDispositionComponent} from './audit-disposition/audit-disposition.component';
import {ModalNewReviewResultComponent} from './modals/modal-new-review-result/modal-new-review-result.component';
import {ModalDispositionMapComponent} from './modals/modal-disposition-map/modal-disposition-map.component';
import {ProviderAuditListComponent} from './provider/provider-audit-list/provider-audit-list.component';
import {ProviderDashboardComponent} from './provider/provider-dashboard/provider-dashboard.component';
import {ModalCancelAuditComponent} from './modals/modal-cancel-audit/modal-cancel-audit.component';
import {ModalProviderEditAuditComponent} from './modals/modal-provider-edit-audit/modal-provider-edit-audit.component';
import {ModalNewLocationComponent} from './modals/modal-new-location/modal-new-location.component';
import {GeofenceComponent} from './geofence/geofence.component';
import {
  ModalGeofenceAddComponentComponent
} from './modals/modal-geofence-add-component/modal-geofence-add-component.component';
import {ProviderDealerListComponent} from './provider/provider-dealer-list/provider-dealer-list.component';
import {ModalAssignAuditComponent} from './modals/modal-assign-audit/modal-assign-audit.component';
import {ModalPlanAuditComponent} from './modals/modal-plan-audit/modal-plan-audit.component';
import {ProviderAuditDetailsComponent} from './provider/provider-audit-details/provider-audit-details.component';
import {ProviderDealerDetailsComponent} from './provider/provider-dealer-details/provider-dealer-details.component';
import {MeComponent} from './common/me/me.component';
import {ModalEditDealerComponent} from './modals/modal-edit-dealer/modal-edit-dealer.component';
import {LoadingComponent} from './waffles/loading/loading.component';
import {ModalEditSelfcheckComponent} from './modals/modal-edit-selfcheck/modal-edit-selfcheck.component';
import {
  ClientModalAuditCancelComponent
} from './client/modals/client-modal-audit-cancel/client-modal-audit-cancel.component';
import {ModalEditAuditComponent} from './modals/modal-edit-audit/modal-edit-audit.component';
import {
  ProviderModalNewAuditComponent
} from './provider/modals/provider-modal-new-audit/provider-modal-new-audit.component';
import {ProviderClientListComponent} from './provider/provider-client-list/provider-client-list.component';
import {ProviderConfigComponent} from './provider/provider-config/provider-config.component';
import {
  ProviderModalAuditorEditComponent
} from './provider/modals/provider-modal-auditor-edit/provider-modal-auditor-edit.component';
import {
  ProviderModalExportAuditComponent
} from './provider/modals/provider-modal-export-audit/provider-modal-export-audit.component';
import {
  ProviderModalExportDealerComponent
} from './provider/modals/provider-modal-export-dealer/provider-modal-export-dealer.component';
import {
  ProviderModalImportByClientComponent
} from './provider/modals/provider-modal-import-by-client/provider-modal-import-by-client.component';
import {ExcCurrency, ExcOrderBy} from './default-settings-service.service';
/* Import locales */
import localeAF from '@angular/common/locales/AF';
// import localeAX from '@angular/common/locales/AX';
// import localeAL from '@angular/common/locales/AL';
import localeDZ from '@angular/common/locales/DZ';
import localeAS from '@angular/common/locales/AS';
// import localeAD from '@angular/common/locales/AD';
// import localeAO from '@angular/common/locales/AO';
// import localeAI from '@angular/common/locales/AI';
// import localeAQ from '@angular/common/locales/AQ';
// import localeAG from '@angular/common/locales/AG';
import localeAR from '@angular/common/locales/AR';
import localeAM from '@angular/common/locales/AM';
// import localeAW from '@angular/common/locales/AW';
// import localeAU from '@angular/common/locales/AU';
// import localeAT from '@angular/common/locales/AT';
import localeAZ from '@angular/common/locales/AZ';
import localeBS from '@angular/common/locales/BS';
// import localeBH from '@angular/common/locales/BH';
// import localeBD from '@angular/common/locales/BD';
// import localeBB from '@angular/common/locales/BB';
// import localeBY from '@angular/common/locales/BY';
import localeBE from '@angular/common/locales/BE';
// import localeBZ from '@angular/common/locales/BZ';
// import localeBJ from '@angular/common/locales/BJ';
import localeBM from '@angular/common/locales/BM';
// import localeBT from '@angular/common/locales/BT';
import localeBO from '@angular/common/locales/BO';
// import localeBQ from '@angular/common/locales/BQ';
// import localeBA from '@angular/common/locales/BA';
// import localeBW from '@angular/common/locales/BW';
// import localeBV from '@angular/common/locales/BV';
import localeBR from '@angular/common/locales/BR';
// import localeIO from '@angular/common/locales/IO';
import localeBN from '@angular/common/locales/BN';
import localeBG from '@angular/common/locales/BG';
// import localeBF from '@angular/common/locales/BF';
// import localeBI from '@angular/common/locales/BI';
// import localeKH from '@angular/common/locales/KH';
// import localeCM from '@angular/common/locales/CM';
import localeCA from '@angular/common/locales/CA';
// import localeCV from '@angular/common/locales/CV';
import localeKY from '@angular/common/locales/KY';
// import localeCF from '@angular/common/locales/CF';
// import localeTD from '@angular/common/locales/TD';
// import localeCL from '@angular/common/locales/CL';
// import localeCN from '@angular/common/locales/CN';
// import localeCX from '@angular/common/locales/CX';
// import localeCC from '@angular/common/locales/CC';
// import localeCO from '@angular/common/locales/CO';
import localeKM from '@angular/common/locales/KM';
// import localeCG from '@angular/common/locales/CG';
// import localeCD from '@angular/common/locales/CD';
// import localeCK from '@angular/common/locales/CK';
// import localeCR from '@angular/common/locales/CR';
// import localeCI from '@angular/common/locales/CI';
import localeHR from '@angular/common/locales/HR';
import localeCU from '@angular/common/locales/CU';
// import localeCW from '@angular/common/locales/CW';
import localeCY from '@angular/common/locales/CY';
// import localeCZ from '@angular/common/locales/CZ';
// import localeDK from '@angular/common/locales/DK';
// import localeDJ from '@angular/common/locales/DJ';
// import localeDM from '@angular/common/locales/DM';
// import localeDO from '@angular/common/locales/DO';
// import localeEC from '@angular/common/locales/EC';
// import localeEG from '@angular/common/locales/EG';
import localeSV from '@angular/common/locales/SV';
// import localeGQ from '@angular/common/locales/GQ';
// import localeER from '@angular/common/locales/ER';
import localeEE from '@angular/common/locales/EE';
import localeET from '@angular/common/locales/ET';
// import localeFK from '@angular/common/locales/FK';
import localeFO from '@angular/common/locales/FO';
// import localeFJ from '@angular/common/locales/FJ';
import localeFI from '@angular/common/locales/FI';
import localeFR from '@angular/common/locales/FR';
// import localeGF from '@angular/common/locales/GF';
// import localePF from '@angular/common/locales/PF';
// import localeTF from '@angular/common/locales/TF';
import localeGA from '@angular/common/locales/GA';
// import localeGM from '@angular/common/locales/GM';
// import localeGE from '@angular/common/locales/GE';
import localeDE from '@angular/common/locales/DE';
// import localeGH from '@angular/common/locales/GH';
// import localeGI from '@angular/common/locales/GI';
// import localeGR from '@angular/common/locales/GR';
import localeGL from '@angular/common/locales/GL';
import localeGD from '@angular/common/locales/GD';
// import localeGP from '@angular/common/locales/GP';
import localeGU from '@angular/common/locales/GU';
// import localeGT from '@angular/common/locales/GT';
// import localeGG from '@angular/common/locales/GG';
// import localeGN from '@angular/common/locales/GN';
// import localeGW from '@angular/common/locales/GW';
// import localeGY from '@angular/common/locales/GY';
// import localeHT from '@angular/common/locales/HT';
// import localeHM from '@angular/common/locales/HM';
// import localeVA from '@angular/common/locales/VA';
// import localeHN from '@angular/common/locales/HN';
// import localeHK from '@angular/common/locales/HK';
import localeHU from '@angular/common/locales/HU';
import localeIS from '@angular/common/locales/IS';
// import localeIN from '@angular/common/locales/IN';
import localeID from '@angular/common/locales/ID';
// import localeIR from '@angular/common/locales/IR';
// import localeIQ from '@angular/common/locales/IQ';
// import localeIE from '@angular/common/locales/IE';
// import localeIM from '@angular/common/locales/IM';
// import localeIL from '@angular/common/locales/IL';
import localeIT from '@angular/common/locales/IT';
// import localeJM from '@angular/common/locales/JM';
// import localeJP from '@angular/common/locales/JP';
// import localeJE from '@angular/common/locales/JE';
// import localeJO from '@angular/common/locales/JO';
// import localeKZ from '@angular/common/locales/KZ';
// import localeKE from '@angular/common/locales/KE';
import localeKI from '@angular/common/locales/KI';
// import localeKP from '@angular/common/locales/KP';
// import localeKR from '@angular/common/locales/KR';
// import localeXK from '@angular/common/locales/XK';
import localeKW from '@angular/common/locales/KW';
// import localeKG from '@angular/common/locales/KG';
// import localeLA from '@angular/common/locales/LA';
import localeLV from '@angular/common/locales/LV';
import localeLB from '@angular/common/locales/LB';
// import localeLS from '@angular/common/locales/LS';
// import localeLR from '@angular/common/locales/LR';
// import localeLY from '@angular/common/locales/LY';
// import localeLI from '@angular/common/locales/LI';
import localeLT from '@angular/common/locales/LT';
import localeLU from '@angular/common/locales/LU';
// import localeMO from '@angular/common/locales/MO';
import localeMK from '@angular/common/locales/MK';
import localeMG from '@angular/common/locales/MG';
// import localeMW from '@angular/common/locales/MW';
import localeMY from '@angular/common/locales/MY';
// import localeMV from '@angular/common/locales/MV';
import localeML from '@angular/common/locales/ML';
import localeMT from '@angular/common/locales/MT';
// import localeMH from '@angular/common/locales/MH';
// import localeMQ from '@angular/common/locales/MQ';
import localeMR from '@angular/common/locales/MR';
// import localeMU from '@angular/common/locales/MU';
// import localeYT from '@angular/common/locales/YT';
// import localeMX from '@angular/common/locales/MX';
// import localeFM from '@angular/common/locales/FM';
// import localeMD from '@angular/common/locales/MD';
// import localeMC from '@angular/common/locales/MC';
import localeMN from '@angular/common/locales/MN';
// import localeME from '@angular/common/locales/ME';
import localeMS from '@angular/common/locales/MS';
// import localeMA from '@angular/common/locales/MA';
// import localeMZ from '@angular/common/locales/MZ';
// import localeMM from '@angular/common/locales/MM';
// import localeNA from '@angular/common/locales/NA';
// import localeNR from '@angular/common/locales/NR';
// import localeNP from '@angular/common/locales/NP';
import localeNL from '@angular/common/locales/NL';
// import localeAN from '@angular/common/locales/AN';
// import localeNC from '@angular/common/locales/NC';
// import localeNZ from '@angular/common/locales/NZ';
// import localeNI from '@angular/common/locales/NI';
import localeNE from '@angular/common/locales/NE';
// import localeNG from '@angular/common/locales/NG';
// import localeNU from '@angular/common/locales/NU';
// import localeNF from '@angular/common/locales/NF';
// import localeMP from '@angular/common/locales/MP';
// import localeNO from '@angular/common/locales/NO';
import localeOM from '@angular/common/locales/OM';
// import localePK from '@angular/common/locales/PK';
// import localePW from '@angular/common/locales/PW';
import localePS from '@angular/common/locales/PS';
import localePA from '@angular/common/locales/PA';
// import localePG from '@angular/common/locales/PG';
// import localePY from '@angular/common/locales/PY';
// import localePE from '@angular/common/locales/PE';
// import localePH from '@angular/common/locales/PH';
// import localePN from '@angular/common/locales/PN';
import localePL from '@angular/common/locales/PL';
import localePT from '@angular/common/locales/PT';
// import localePR from '@angular/common/locales/PR';
// import localeQA from '@angular/common/locales/QA';
// import localeRS from '@angular/common/locales/RS';
// import localeRE from '@angular/common/locales/RE';
import localeRO from '@angular/common/locales/RO';
import localeRU from '@angular/common/locales/RU';
import localeRW from '@angular/common/locales/RW';
// import localeBL from '@angular/common/locales/BL';
// import localeSH from '@angular/common/locales/SH';
import localeKN from '@angular/common/locales/KN';
// import localeLC from '@angular/common/locales/LC';
// import localeMF from '@angular/common/locales/MF';
// import localePM from '@angular/common/locales/PM';
// import localeVC from '@angular/common/locales/VC';
// import localeWS from '@angular/common/locales/WS';
// import localeSM from '@angular/common/locales/SM';
// import localeST from '@angular/common/locales/ST';
// import localeSA from '@angular/common/locales/SA';
import localeSN from '@angular/common/locales/SN';
import localeCS from '@angular/common/locales/CS';
// import localeSC from '@angular/common/locales/SC';
import localeSL from '@angular/common/locales/SL';
import localeSG from '@angular/common/locales/SG';
// import localeSX from '@angular/common/locales/SX';
import localeSK from '@angular/common/locales/SK';
import localeSI from '@angular/common/locales/SI';
// import localeSB from '@angular/common/locales/SB';
import localeSO from '@angular/common/locales/SO';
// import localeZA from '@angular/common/locales/ZA';
// import localeGS from '@angular/common/locales/GS';
// import localeSS from '@angular/common/locales/SS';
import localeES from '@angular/common/locales/ES';
// import localeLK from '@angular/common/locales/LK';
import localeSD from '@angular/common/locales/SD';
import localeSR from '@angular/common/locales/SR';
// import localeSJ from '@angular/common/locales/SJ';
// import localeSZ from '@angular/common/locales/SZ';
import localeSE from '@angular/common/locales/SE';
// import localeCH from '@angular/common/locales/CH';
// import localeSY from '@angular/common/locales/SY';
// import localeTW from '@angular/common/locales/TW';
// import localeTJ from '@angular/common/locales/TJ';
// import localeTZ from '@angular/common/locales/TZ';
import localeTH from '@angular/common/locales/TH';
// import localeTL from '@angular/common/locales/TL';
import localeTG from '@angular/common/locales/TG';
import localeTK from '@angular/common/locales/TK';
import localeTO from '@angular/common/locales/TO';
import localeTT from '@angular/common/locales/TT';
// import localeTN from '@angular/common/locales/TN';
import localeTR from '@angular/common/locales/TR';
// import localeXT from '@angular/common/locales/XT';
// import localeTM from '@angular/common/locales/TM';
// import localeTC from '@angular/common/locales/TC';
// import localeTV from '@angular/common/locales/TV';
import localeUG from '@angular/common/locales/UG';
// import localeUA from '@angular/common/locales/UA';
// import localeAE from '@angular/common/locales/AE';
// import localeGB from '@angular/common/locales/GB';
// import localeUS from '@angular/common/locales/US';
// import localeUM from '@angular/common/locales/UM';
// import localeUY from '@angular/common/locales/UY';
import localeUZ from '@angular/common/locales/UZ';
// import localeVU from '@angular/common/locales/VU';
// import localeVE from '@angular/common/locales/VE';
// import localeVN from '@angular/common/locales/VN';
// import localeVG from '@angular/common/locales/VG';
import localeVI from '@angular/common/locales/VI';
// import localeWF from '@angular/common/locales/WF';
// import localeEH from '@angular/common/locales/EH';
// import localeYE from '@angular/common/locales/YE';
// import localeZM from '@angular/common/locales/ZM';
// import localeZW from '@angular/common/locales/ZW';
import localeAFExtra from '@angular/common/locales/extra/AF';
// import localeAXExtra from '@angular/common/locales/extra/AX';
// import localeALExtra from '@angular/common/locales/extra/AL';
import localeDZExtra from '@angular/common/locales/extra/DZ';
import localeASExtra from '@angular/common/locales/extra/AS';
// import localeADExtra from '@angular/common/locales/extra/AD';
// import localeAOExtra from '@angular/common/locales/extra/AO';
// import localeAIExtra from '@angular/common/locales/extra/AI';
// import localeAQExtra from '@angular/common/locales/extra/AQ';
// import localeAGExtra from '@angular/common/locales/extra/AG';
import localeARExtra from '@angular/common/locales/extra/AR';
import localeAMExtra from '@angular/common/locales/extra/AM';
// import localeAWExtra from '@angular/common/locales/extra/AW';
// import localeAUExtra from '@angular/common/locales/extra/AU';
// import localeATExtra from '@angular/common/locales/extra/AT';
import localeAZExtra from '@angular/common/locales/extra/AZ';
import localeBSExtra from '@angular/common/locales/extra/BS';
// import localeBHExtra from '@angular/common/locales/extra/BH';
// import localeBDExtra from '@angular/common/locales/extra/BD';
// import localeBBExtra from '@angular/common/locales/extra/BB';
// import localeBYExtra from '@angular/common/locales/extra/BY';
import localeBEExtra from '@angular/common/locales/extra/BE';
// import localeBZExtra from '@angular/common/locales/extra/BZ';
// import localeBJExtra from '@angular/common/locales/extra/BJ';
import localeBMExtra from '@angular/common/locales/extra/BM';
// import localeBTExtra from '@angular/common/locales/extra/BT';
import localeBOExtra from '@angular/common/locales/extra/BO';
// import localeBQExtra from '@angular/common/locales/extra/BQ';
// import localeBAExtra from '@angular/common/locales/extra/BA';
// import localeBWExtra from '@angular/common/locales/extra/BW';
// import localeBVExtra from '@angular/common/locales/extra/BV';
import localeBRExtra from '@angular/common/locales/extra/BR';
// import localeIOExtra from '@angular/common/locales/extra/IO';
import localeBNExtra from '@angular/common/locales/extra/BN';
import localeBGExtra from '@angular/common/locales/extra/BG';
// import localeBFExtra from '@angular/common/locales/extra/BF';
// import localeBIExtra from '@angular/common/locales/extra/BI';
// import localeKHExtra from '@angular/common/locales/extra/KH';
// import localeCMExtra from '@angular/common/locales/extra/CM';
import localeCAExtra from '@angular/common/locales/extra/CA';
// import localeCVExtra from '@angular/common/locales/extra/CV';
import localeKYExtra from '@angular/common/locales/extra/KY';
// import localeCFExtra from '@angular/common/locales/extra/CF';
// import localeTDExtra from '@angular/common/locales/extra/TD';
// import localeCLExtra from '@angular/common/locales/extra/CL';
// import localeCNExtra from '@angular/common/locales/extra/CN';
// import localeCXExtra from '@angular/common/locales/extra/CX';
// import localeCCExtra from '@angular/common/locales/extra/CC';
// import localeCOExtra from '@angular/common/locales/extra/CO';
import localeKMExtra from '@angular/common/locales/extra/KM';
// import localeCGExtra from '@angular/common/locales/extra/CG';
// import localeCDExtra from '@angular/common/locales/extra/CD';
// import localeCKExtra from '@angular/common/locales/extra/CK';
// import localeCRExtra from '@angular/common/locales/extra/CR';
// import localeCIExtra from '@angular/common/locales/extra/CI';
import localeHRExtra from '@angular/common/locales/extra/HR';
import localeCUExtra from '@angular/common/locales/extra/CU';
// import localeCWExtra from '@angular/common/locales/extra/CW';
import localeCYExtra from '@angular/common/locales/extra/CY';
// import localeCZExtra from '@angular/common/locales/extra/CZ';
// import localeDKExtra from '@angular/common/locales/extra/DK';
// import localeDJExtra from '@angular/common/locales/extra/DJ';
// import localeDMExtra from '@angular/common/locales/extra/DM';
// import localeDOExtra from '@angular/common/locales/extra/DO';
// import localeECExtra from '@angular/common/locales/extra/EC';
// import localeEGExtra from '@angular/common/locales/extra/EG';
import localeSVExtra from '@angular/common/locales/extra/SV';
// import localeGQExtra from '@angular/common/locales/extra/GQ';
// import localeERExtra from '@angular/common/locales/extra/ER';
import localeEEExtra from '@angular/common/locales/extra/EE';
import localeETExtra from '@angular/common/locales/extra/ET';
// import localeFKExtra from '@angular/common/locales/extra/FK';
import localeFOExtra from '@angular/common/locales/extra/FO';
// import localeFJExtra from '@angular/common/locales/extra/FJ';
import localeFIExtra from '@angular/common/locales/extra/FI';
import localeFRExtra from '@angular/common/locales/extra/FR';
// import localeGFExtra from '@angular/common/locales/extra/GF';
// import localePFExtra from '@angular/common/locales/extra/PF';
// import localeTFExtra from '@angular/common/locales/extra/TF';
import localeGAExtra from '@angular/common/locales/extra/GA';
// import localeGMExtra from '@angular/common/locales/extra/GM';
// import localeGEExtra from '@angular/common/locales/extra/GE';
import localeDEExtra from '@angular/common/locales/extra/DE';
// import localeGHExtra from '@angular/common/locales/extra/GH';
// import localeGIExtra from '@angular/common/locales/extra/GI';
// import localeGRExtra from '@angular/common/locales/extra/GR';
import localeGLExtra from '@angular/common/locales/extra/GL';
import localeGDExtra from '@angular/common/locales/extra/GD';
// import localeGPExtra from '@angular/common/locales/extra/GP';
import localeGUExtra from '@angular/common/locales/extra/GU';
// import localeGTExtra from '@angular/common/locales/extra/GT';
// import localeGGExtra from '@angular/common/locales/extra/GG';
// import localeGNExtra from '@angular/common/locales/extra/GN';
// import localeGWExtra from '@angular/common/locales/extra/GW';
// import localeGYExtra from '@angular/common/locales/extra/GY';
// import localeHTExtra from '@angular/common/locales/extra/HT';
// import localeHMExtra from '@angular/common/locales/extra/HM';
// import localeVAExtra from '@angular/common/locales/extra/VA';
// import localeHNExtra from '@angular/common/locales/extra/HN';
// import localeHKExtra from '@angular/common/locales/extra/HK';
import localeHUExtra from '@angular/common/locales/extra/HU';
import localeISExtra from '@angular/common/locales/extra/IS';
// import localeINExtra from '@angular/common/locales/extra/IN';
import localeIDExtra from '@angular/common/locales/extra/ID';
// import localeIRExtra from '@angular/common/locales/extra/IR';
// import localeIQExtra from '@angular/common/locales/extra/IQ';
// import localeIEExtra from '@angular/common/locales/extra/IE';
// import localeIMExtra from '@angular/common/locales/extra/IM';
// import localeILExtra from '@angular/common/locales/extra/IL';
import localeITExtra from '@angular/common/locales/extra/IT';
// import localeJMExtra from '@angular/common/locales/extra/JM';
// import localeJPExtra from '@angular/common/locales/extra/JP';
// import localeJEExtra from '@angular/common/locales/extra/JE';
// import localeJOExtra from '@angular/common/locales/extra/JO';
// import localeKZExtra from '@angular/common/locales/extra/KZ';
// import localeKEExtra from '@angular/common/locales/extra/KE';
import localeKIExtra from '@angular/common/locales/extra/KI';
// import localeKPExtra from '@angular/common/locales/extra/KP';
// import localeKRExtra from '@angular/common/locales/extra/KR';
// import localeXKExtra from '@angular/common/locales/extra/XK';
import localeKWExtra from '@angular/common/locales/extra/KW';
// import localeKGExtra from '@angular/common/locales/extra/KG';
// import localeLAExtra from '@angular/common/locales/extra/LA';
import localeLVExtra from '@angular/common/locales/extra/LV';
import localeLBExtra from '@angular/common/locales/extra/LB';
// import localeLSExtra from '@angular/common/locales/extra/LS';
// import localeLRExtra from '@angular/common/locales/extra/LR';
// import localeLYExtra from '@angular/common/locales/extra/LY';
// import localeLIExtra from '@angular/common/locales/extra/LI';
import localeLTExtra from '@angular/common/locales/extra/LT';
import localeLUExtra from '@angular/common/locales/extra/LU';
// import localeMOExtra from '@angular/common/locales/extra/MO';
import localeMKExtra from '@angular/common/locales/extra/MK';
import localeMGExtra from '@angular/common/locales/extra/MG';
// import localeMWExtra from '@angular/common/locales/extra/MW';
import localeMYExtra from '@angular/common/locales/extra/MY';
// import localeMVExtra from '@angular/common/locales/extra/MV';
import localeMLExtra from '@angular/common/locales/extra/ML';
import localeMTExtra from '@angular/common/locales/extra/MT';
// import localeMHExtra from '@angular/common/locales/extra/MH';
// import localeMQExtra from '@angular/common/locales/extra/MQ';
import localeMRExtra from '@angular/common/locales/extra/MR';
// import localeMUExtra from '@angular/common/locales/extra/MU';
// import localeYTExtra from '@angular/common/locales/extra/YT';
// import localeMXExtra from '@angular/common/locales/extra/MX';
// import localeFMExtra from '@angular/common/locales/extra/FM';
// import localeMDExtra from '@angular/common/locales/extra/MD';
// import localeMCExtra from '@angular/common/locales/extra/MC';
import localeMNExtra from '@angular/common/locales/extra/MN';
// import localeMEExtra from '@angular/common/locales/extra/ME';
import localeMSExtra from '@angular/common/locales/extra/MS';
// import localeMAExtra from '@angular/common/locales/extra/MA';
// import localeMZExtra from '@angular/common/locales/extra/MZ';
// import localeMMExtra from '@angular/common/locales/extra/MM';
// import localeNAExtra from '@angular/common/locales/extra/NA';
// import localeNRExtra from '@angular/common/locales/extra/NR';
// import localeNPExtra from '@angular/common/locales/extra/NP';
import localeNLExtra from '@angular/common/locales/extra/NL';
// import localeANExtra from '@angular/common/locales/extra/AN';
// import localeNCExtra from '@angular/common/locales/extra/NC';
// import localeNZExtra from '@angular/common/locales/extra/NZ';
// import localeNIExtra from '@angular/common/locales/extra/NI';
import localeNEExtra from '@angular/common/locales/extra/NE';
// import localeNGExtra from '@angular/common/locales/extra/NG';
// import localeNUExtra from '@angular/common/locales/extra/NU';
// import localeNFExtra from '@angular/common/locales/extra/NF';
// import localeMPExtra from '@angular/common/locales/extra/MP';
// import localeNOExtra from '@angular/common/locales/extra/NO';
import localeOMExtra from '@angular/common/locales/extra/OM';
// import localePKExtra from '@angular/common/locales/extra/PK';
// import localePWExtra from '@angular/common/locales/extra/PW';
import localePSExtra from '@angular/common/locales/extra/PS';
import localePAExtra from '@angular/common/locales/extra/PA';
// import localePGExtra from '@angular/common/locales/extra/PG';
// import localePYExtra from '@angular/common/locales/extra/PY';
// import localePEExtra from '@angular/common/locales/extra/PE';
// import localePHExtra from '@angular/common/locales/extra/PH';
// import localePNExtra from '@angular/common/locales/extra/PN';
import localePLExtra from '@angular/common/locales/extra/PL';
import localePTExtra from '@angular/common/locales/extra/PT';
// import localePRExtra from '@angular/common/locales/extra/PR';
// import localeQAExtra from '@angular/common/locales/extra/QA';
// import localeRSExtra from '@angular/common/locales/extra/RS';
// import localeREExtra from '@angular/common/locales/extra/RE';
import localeROExtra from '@angular/common/locales/extra/RO';
import localeRUExtra from '@angular/common/locales/extra/RU';
import localeRWExtra from '@angular/common/locales/extra/RW';
// import localeBLExtra from '@angular/common/locales/extra/BL';
// import localeSHExtra from '@angular/common/locales/extra/SH';
import localeKNExtra from '@angular/common/locales/extra/KN';
// import localeLCExtra from '@angular/common/locales/extra/LC';
// import localeMFExtra from '@angular/common/locales/extra/MF';
// import localePMExtra from '@angular/common/locales/extra/PM';
// import localeVCExtra from '@angular/common/locales/extra/VC';
// import localeWSExtra from '@angular/common/locales/extra/WS';
// import localeSMExtra from '@angular/common/locales/extra/SM';
// import localeSTExtra from '@angular/common/locales/extra/ST';
// import localeSAExtra from '@angular/common/locales/extra/SA';
import localeSNExtra from '@angular/common/locales/extra/SN';
import localeCSExtra from '@angular/common/locales/extra/CS';
// import localeSCExtra from '@angular/common/locales/extra/SC';
import localeSLExtra from '@angular/common/locales/extra/SL';
import localeSGExtra from '@angular/common/locales/extra/SG';
// import localeSXExtra from '@angular/common/locales/extra/SX';
import localeSKExtra from '@angular/common/locales/extra/SK';
import localeSIExtra from '@angular/common/locales/extra/SI';
// import localeSBExtra from '@angular/common/locales/extra/SB';
import localeSOExtra from '@angular/common/locales/extra/SO';
// import localeZAExtra from '@angular/common/locales/extra/ZA';
// import localeGSExtra from '@angular/common/locales/extra/GS';
// import localeSSExtra from '@angular/common/locales/extra/SS';
import localeESExtra from '@angular/common/locales/extra/ES';
// import localeLKExtra from '@angular/common/locales/extra/LK';
import localeSDExtra from '@angular/common/locales/extra/SD';
import localeSRExtra from '@angular/common/locales/extra/SR';
// import localeSJExtra from '@angular/common/locales/extra/SJ';
// import localeSZExtra from '@angular/common/locales/extra/SZ';
import localeSEExtra from '@angular/common/locales/extra/SE';
// import localeCHExtra from '@angular/common/locales/extra/CH';
// import localeSYExtra from '@angular/common/locales/extra/SY';
// import localeTWExtra from '@angular/common/locales/extra/TW';
// import localeTJExtra from '@angular/common/locales/extra/TJ';
// import localeTZExtra from '@angular/common/locales/extra/TZ';
import localeTHExtra from '@angular/common/locales/extra/TH';
// import localeTLExtra from '@angular/common/locales/extra/TL';
import localeTGExtra from '@angular/common/locales/extra/TG';
import localeTKExtra from '@angular/common/locales/extra/TK';
import localeTOExtra from '@angular/common/locales/extra/TO';
import localeTTExtra from '@angular/common/locales/extra/TT';
// import localeTNExtra from '@angular/common/locales/extra/TN';
import localeTRExtra from '@angular/common/locales/extra/TR';
// import localeXTExtra from '@angular/common/locales/extra/XT';
// import localeTMExtra from '@angular/common/locales/extra/TM';
// import localeTCExtra from '@angular/common/locales/extra/TC';
// import localeTVExtra from '@angular/common/locales/extra/TV';
import localeUGExtra from '@angular/common/locales/extra/UG';
// import localeUAExtra from '@angular/common/locales/extra/UA';
// import localeAEExtra from '@angular/common/locales/extra/AE';
// import localeGBExtra from '@angular/common/locales/extra/GB';
// import localeUSExtra from '@angular/common/locales/extra/US';
// import localeUMExtra from '@angular/common/locales/extra/UM';
// import localeUYExtra from '@angular/common/locales/extra/UY';
import localeUZExtra from '@angular/common/locales/extra/UZ';
// import localeVUExtra from '@angular/common/locales/extra/VU';
// import localeVEExtra from '@angular/common/locales/extra/VE';
// import localeVNExtra from '@angular/common/locales/extra/VN';
// import localeVGExtra from '@angular/common/locales/extra/VG';
import localeVIExtra from '@angular/common/locales/extra/VI';
import {ModalFollowupDateEditComponent} from './modals/modal-followup-date-edit/modal-followup-date-edit.component';
import {ExconClientListComponent} from './excon/excon-client-list/excon-client-list.component';
import {ModalReviewGroupEditComponent} from './modals/modal-review-group-edit/modal-review-group-edit.component';
import {ModalReviewGroupCreateComponent} from './modals/modal-review-group-create/modal-review-group-create.component';
import {
  ModalReviewGroupEditDescriptionComponent
} from './modals/modal-review-group-edit-description/modal-review-group-edit-description.component';
import {ModalReviewGroupAddComponent} from './modals/modal-review-group-add/modal-review-group-add.component';
import {ReviewAuditItemComponent} from './common/review-audit-item/review-audit-item.component';
import {AuditPlanningComponent} from './audit-planning/audit-planning.component';
import {ExconAuditListComponent} from './excon/excon-audit-list/excon-audit-list.component';
import {ExconAuditDetailsComponent} from './excon/excon-audit-details/excon-audit-details.component';
import {ExconDealerDetailsComponent} from './excon/excon-dealer-details/excon-dealer-details.component';
import {ExconDealerListComponent} from './excon/excon-dealer-list/excon-dealer-list.component';
import {ExconClientDetailsComponent} from './excon/excon-client-details/excon-client-details.component';
import {ExconClientWaffleComponent} from './excon/waffles/excon-client-waffle/excon-client-waffle.component';
import {CalendarComponent} from './client/calendar/calendar.component';
import {
  ProviderModalDispositionBatchComponent
} from './provider/modals/provider-modal-disposition-batch/provider-modal-disposition-batch.component';
import {SequenceComponent} from './config/selfcheck/sequence/sequence.component';
import {SequenceStepComponent} from './config/selfcheck/sequence-step/sequence-step.component';
import {MessageTextComponent} from './config/selfcheck/message-text/message-text.component';
import {ModalReportComponent} from './modals/modal-report/modal-report.component';
import {ModalReportEditComponent} from './modals/modal-report-edit/modal-report-edit.component';
// import localeWFExtra from '@angular/common/locales/extra/WF';
// import localeEHExtra from '@angular/common/locales/extra/EH';
// import localeYEExtra from '@angular/common/locales/extra/YE';
// import localeZMExtra from '@angular/common/locales/extra/ZM';
// import localeZWExtra from '@angular/common/locales/extra/ZW';
import {RichTextEditorAllModule} from '@syncfusion/ej2-angular-richtexteditor';
import {ModalReportAboEditComponent} from './modals/modal-report-abo-edit/modal-report-abo-edit.component';
import {ReviewListDoneComponent} from './review-list-done/review-list-done';
import {AuditListPendingComponent} from './audit-list-pending/audit-list-pending';
import {PendingAuditItemComponent} from './common/pending-audit-item/pending-audit-item.component';
import {ReviewDoneItemComponent} from './common/review-done-item/review-done-item.component';
import {ModalCreateStepComponent} from './config/selfcheck/sequence-step/modal-create-step/modal-create-step.component';
import {PlanningHq2OverviewComponent} from './planning-hq2-overview/planning-hq2-overview.component';
import { ModalDealerBlackWhiteListComponent } from './modals/modal-dealer-black-white-list/modal-dealer-black-white-list.component';
import { ModalAuditReopenComponent } from './modals/modal-audit-reopen/modal-audit-reopen.component';
import { ModalDealerSuccessorComponent } from './modals/modal-dealer-successor/modal-dealer-successor.component';
import {AppSearchbarComponent} from './misc/app-searchbar/app-searchbar.component';


registerLocaleData(localeAF, 'AF', localeAFExtra);
registerLocaleData(localeDZ, 'DZ', localeDZExtra);
registerLocaleData(localeAS, 'AS', localeASExtra);
registerLocaleData(localeAR, 'AR', localeARExtra);
registerLocaleData(localeAM, 'AM', localeAMExtra);
registerLocaleData(localeAZ, 'AZ', localeAZExtra);
registerLocaleData(localeBS, 'BS', localeBSExtra);
registerLocaleData(localeBE, 'BE', localeBEExtra);
registerLocaleData(localeBM, 'BM', localeBMExtra);
registerLocaleData(localeBO, 'BO', localeBOExtra);
registerLocaleData(localeBR, 'BR', localeBRExtra);
registerLocaleData(localeBN, 'BN', localeBNExtra);
registerLocaleData(localeBG, 'BG', localeBGExtra);
registerLocaleData(localeCA, 'CA', localeCAExtra);
registerLocaleData(localeKY, 'KY', localeKYExtra);
registerLocaleData(localeKM, 'KM', localeKMExtra);
registerLocaleData(localeHR, 'HR', localeHRExtra);
registerLocaleData(localeCU, 'CU', localeCUExtra);
registerLocaleData(localeCY, 'CY', localeCYExtra);
registerLocaleData(localeSV, 'SV', localeSVExtra);
registerLocaleData(localeEE, 'EE', localeEEExtra);
registerLocaleData(localeET, 'ET', localeETExtra);
registerLocaleData(localeFO, 'FO', localeFOExtra);
registerLocaleData(localeFI, 'FI', localeFIExtra);
registerLocaleData(localeFR, 'FR', localeFRExtra);
registerLocaleData(localeGA, 'GA', localeGAExtra);
registerLocaleData(localeDE, 'DE', localeDEExtra);
registerLocaleData(localeGL, 'GL', localeGLExtra);
registerLocaleData(localeGD, 'GD', localeGDExtra);
registerLocaleData(localeGU, 'GU', localeGUExtra);
registerLocaleData(localeHU, 'HU', localeHUExtra);
registerLocaleData(localeIS, 'IS', localeISExtra);
registerLocaleData(localeID, 'ID', localeIDExtra);
registerLocaleData(localeIT, 'IT', localeITExtra);
registerLocaleData(localeKI, 'KI', localeKIExtra);
registerLocaleData(localeKW, 'KW', localeKWExtra);
registerLocaleData(localeLV, 'LV', localeLVExtra);
registerLocaleData(localeLB, 'LB', localeLBExtra);
registerLocaleData(localeLT, 'LT', localeLTExtra);
registerLocaleData(localeLU, 'LU', localeLUExtra);
registerLocaleData(localeMK, 'MK', localeMKExtra);
registerLocaleData(localeMG, 'MG', localeMGExtra);
registerLocaleData(localeMY, 'MY', localeMYExtra);
registerLocaleData(localeML, 'ML', localeMLExtra);
registerLocaleData(localeMT, 'MT', localeMTExtra);
registerLocaleData(localeMR, 'MR', localeMRExtra);
registerLocaleData(localeMN, 'MN', localeMNExtra);
registerLocaleData(localeMS, 'MS', localeMSExtra);
registerLocaleData(localeNL, 'NL', localeNLExtra);
registerLocaleData(localeNE, 'NE', localeNEExtra);
registerLocaleData(localeOM, 'OM', localeOMExtra);
registerLocaleData(localePS, 'PS', localePSExtra);
registerLocaleData(localePA, 'PA', localePAExtra);
registerLocaleData(localePL, 'PL', localePLExtra);
registerLocaleData(localePT, 'PT', localePTExtra);
registerLocaleData(localeRO, 'RO', localeROExtra);
registerLocaleData(localeRU, 'RU', localeRUExtra);
registerLocaleData(localeRW, 'RW', localeRWExtra);
registerLocaleData(localeKN, 'KN', localeKNExtra);
registerLocaleData(localeSN, 'SN', localeSNExtra);
registerLocaleData(localeCS, 'CS', localeCSExtra);
registerLocaleData(localeSL, 'SL', localeSLExtra);
registerLocaleData(localeSG, 'SG', localeSGExtra);
registerLocaleData(localeSK, 'SK', localeSKExtra);
registerLocaleData(localeSI, 'SI', localeSIExtra);
registerLocaleData(localeSO, 'SO', localeSOExtra);
registerLocaleData(localeES, 'ES', localeESExtra);
registerLocaleData(localeSD, 'SD', localeSDExtra);
registerLocaleData(localeSR, 'SR', localeSRExtra);
registerLocaleData(localeSE, 'SE', localeSEExtra);
registerLocaleData(localeTH, 'TH', localeTHExtra);
registerLocaleData(localeTG, 'TG', localeTGExtra);
registerLocaleData(localeTK, 'TK', localeTKExtra);
registerLocaleData(localeTO, 'TO', localeTOExtra);
registerLocaleData(localeTT, 'TT', localeTTExtra);
registerLocaleData(localeTR, 'TR', localeTRExtra);
registerLocaleData(localeUG, 'UG', localeUGExtra);
registerLocaleData(localeUZ, 'UZ', localeUZExtra);
registerLocaleData(localeVI, 'VI', localeVIExtra);


/* ---------- */
// import localeDeExtra from '@angular/common/locales/extra/de';
// import localeEnExtra from '@angular/common/locales/extra/en';
// import localeHuExtra from '@angular/common/locales/extra/hu';
// import localeDe from '@angular/common/locales/de';
// import localeEn from '@angular/common/locales/en';
// import localeHu from '@angular/common/locales/hu';
// registerLocaleData(localeDe, 'de', localeDeExtra);
// registerLocaleData(localeEn, 'en', localeEnExtra);
// registerLocaleData(localeHu, 'hu', localeHuExtra);
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    OrderOpenComponent,
    OrderFinishedComponent,
    OrderDetailsComponent,
    AppExcChartComponent,
    AppExcProgbarComponent,
    ModalInfoMailComponent,
    AppExcIndicatorComponent,
    AppExcGayNumberComponent,
    OrderCreateComponent,
    PlanningHqComponent,
    SearchSlimComponent,
    DealerListComponent,
    DealerDetailsComponent,
    AuditItemSmallComponent,
    HistoryItemSmallComponent,
    AuditRecentComponent,
    ModalNewAuditComponent,
    ModalDealerEditComponent,
    ModalPlanningHqHelpComponent,
    ModalPlanningHqWarningComponent,
    AuditDetailsComponent,
    AuditScoreComponent,
    PlanningHq2Component,
    ModalPlanningHqApprovalComponent,
    ModalPlanningHqAuditDetailComponent,
    InventoryItemSmallComponent,
    AuditWaffleComponent,
    InventoryWaffleComponent,
    InventoryResultWaffleComponent,
    DealerWaffleComponent,
    MandantWaffleComponent,
    ResultWaffleComponent,
    CommentWaffleComponent,
    InventoryDetailsComponent,
    ModalPlanningHqSettingsComponent,
    KanbanComponent,
    KanbanItemComponent,
    ModalKanbanResendCodeComponent,
    ModalKanbanResetPinComponent,
    ModalAuditCancelComponent,
    ModalYesNoComponent,
    ModalAuditPinChangedComponent,
    ModalAuditExtendComponent,
    ModalCommentComponent,
    ModalResendCodeComponent,
    KanbanItemComponent,
    SliderElementDirective,
    SliderComponent,
    SliderControlsComponent,
    ChartSliderComponent,
    SingleChartComponent,
    ExcUploadDialogComponent,
    ExcAttachmentsComponent,
    ExcFileInputComponent,
    ExcUploadRequiredValidator,
    ExcUploadDirective,
    ExcDirectUploadDirective,
    AuditReviewComponent,
    ReviewListOpenComponent,
    ReviewListOpenItemComponent,
    ModalAssignReviewsComponent,
    AttachmentViewerComponent,
    DataImportComponent,
    DataImportEditMailModalComponent,
    ReviewInboxComponent,
    DataImportUploadConfirmModalComponent,
    ModalReviewFinsihComponent,
    DefaultableInputComponent,
    ConfigComponent,
    ClientConfigComponent,
    ModalReviewBatchEditComponent,
    AuditLandingStripComponent,
    AuditDispositionComponent,
    ModalNewReviewResultComponent,
    ModalDispositionMapComponent,
    ProviderAuditListComponent,
    ProviderDashboardComponent,
    ModalCancelAuditComponent,
    ModalProviderEditAuditComponent,
    ModalNewLocationComponent,
    GeofenceComponent,
    ModalGeofenceAddComponentComponent,
    ProviderDealerListComponent,
    ModalAssignAuditComponent,
    ModalPlanAuditComponent,
    ProviderAuditDetailsComponent,
    ProviderDealerDetailsComponent,
    MeComponent,
    ModalEditDealerComponent,
    LoadingComponent,
    ModalEditSelfcheckComponent,
    ClientModalAuditCancelComponent,
    ModalEditAuditComponent,
    HtmlContentPipe,
    ProviderModalNewAuditComponent,
    ProviderClientListComponent,
    ProviderConfigComponent,
    ProviderModalAuditorEditComponent,
    ProviderModalExportAuditComponent,
    ProviderModalExportDealerComponent,
    ProviderModalImportByClientComponent,
    ExcCurrency,
    ModalFollowupDateEditComponent,
    ExconClientListComponent,
    ModalReviewGroupEditComponent,
    ModalReviewGroupCreateComponent,
    ModalReviewGroupEditDescriptionComponent,
    ModalReviewGroupAddComponent,
    ReviewAuditItemComponent,
    AuditPlanningComponent,
    ExconAuditListComponent,
    ExconAuditDetailsComponent,
    ExconDealerListComponent,
    ExconDealerDetailsComponent,
    ExconClientDetailsComponent,
    ExconClientWaffleComponent,
    CalendarComponent,
    ProviderModalDispositionBatchComponent,
    ExcOrderBy,
    ScConfigComponent,
    SequenceComponent,
    SequenceStepComponent,
    MessageTextComponent,
    ModalCreateStepComponent,
    ModalReportComponent,
    ModalReportEditComponent,
    ModalReportAboEditComponent,
    ReviewListDoneComponent,
    AuditListPendingComponent,
    PendingAuditItemComponent,
    ReviewDoneItemComponent,
    PlanningHq2OverviewComponent,
    ModalDealerBlackWhiteListComponent,
    ModalAuditReopenComponent,
    ModalDealerSuccessorComponent,
    AppSearchbarComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    ExcCoreModule,
    ExcTabModule,
    ExcRestModule,
    ExcSigninModule,
    ExcControlsModule,
    ExcMapModule,
    BrowserAnimationsModule,
    OverlayPanelModule,
    ToastModule,
    InputTextModule,
    TooltipModule,
    PdfViewerModule,
    ExcSigninUiModule,
    RichTextEditorAllModule,

    /*   SimplePdfViewerModule,*/
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  entryComponents: [
    OrderDetailsComponent,
    AppExcChartComponent,
    AppExcProgbarComponent,
    ModalInfoMailComponent,
    AppExcGayNumberComponent,
    OrderCreateComponent,
    SearchSlimComponent,
    DealerListComponent,
    DealerDetailsComponent,
    AuditItemSmallComponent,
    HistoryItemSmallComponent,
    AuditRecentComponent,
    ModalNewAuditComponent,
    ModalDealerEditComponent,
    ModalPlanningHqHelpComponent,
    ModalPlanningHqWarningComponent,
    AuditDetailsComponent,
    PlanningHq2Component,
    ModalPlanningHqApprovalComponent,
    ModalPlanningHqAuditDetailComponent,
    InventoryItemSmallComponent,
    ModalPlanningHqSettingsComponent,
    KanbanComponent,
    KanbanItemComponent,
    ModalKanbanResendCodeComponent,
    ModalKanbanResetPinComponent,
    ModalAuditCancelComponent,
    ModalYesNoComponent,
    ModalAuditPinChangedComponent,
    ModalAuditExtendComponent,
    ModalCommentComponent,
    ModalResendCodeComponent,
    KanbanItemComponent,
    SingleChartComponent,
    ExcUploadDialogComponent,
    InventoryDetailsComponent,
    AuditReviewComponent,
    ReviewListOpenComponent,
    ModalAssignReviewsComponent,
    AttachmentViewerComponent,
    DataImportEditMailModalComponent,
    ReviewInboxComponent,
    DataImportUploadConfirmModalComponent,
    ModalReviewFinsihComponent,
    ConfigComponent,
    ModalReviewBatchEditComponent,
    AuditDispositionComponent,
    ModalNewReviewResultComponent,
    ModalDispositionMapComponent,
    ProviderAuditListComponent,
    ModalCancelAuditComponent,
    ModalProviderEditAuditComponent,
    ModalNewLocationComponent,
    GeofenceComponent,
    ModalGeofenceAddComponentComponent,
    ProviderDealerListComponent,
    ModalAssignAuditComponent,
    ModalPlanAuditComponent,
    ProviderAuditDetailsComponent,
    ProviderDealerDetailsComponent,
    ModalEditDealerComponent,
    ModalEditSelfcheckComponent,
    ClientModalAuditCancelComponent,
    ProviderModalNewAuditComponent,
    ProviderConfigComponent,
    ProviderModalAuditorEditComponent,
    ProviderModalExportAuditComponent,
    ProviderModalExportDealerComponent,
    ProviderModalImportByClientComponent,
    ModalFollowupDateEditComponent,
    ExconClientListComponent,
    ModalReviewGroupEditComponent,
    ModalReviewGroupCreateComponent,
    ModalReviewGroupAddComponent,
    ModalReviewGroupEditDescriptionComponent,
    ReviewAuditItemComponent,
    AuditPlanningComponent,
    ExconAuditListComponent,
    ExconAuditDetailsComponent,
    ExconDealerListComponent,
    ExconDealerDetailsComponent,
    ExconClientDetailsComponent,
    ExconClientWaffleComponent,
    ProviderModalDispositionBatchComponent,
    ScConfigComponent,
    ModalCreateStepComponent,
    ModalReportComponent,
    ModalReportEditComponent,
    ModalReportAboEditComponent,
    ReviewListDoneComponent,
    PendingAuditItemComponent,
    AuditListPendingComponent,
    ReviewDoneItemComponent,
    PlanningHq2OverviewComponent,
    ModalDealerBlackWhiteListComponent,
    ModalAuditReopenComponent,
    ModalDealerSuccessorComponent
  ],
  providers: [StateSecurityProcessor,
    DatePipe,
    CurrencyPipe,
    ExcOrderBy,
    ExcCurrency],
  bootstrap: [AppComponent]
})
export class AppModule {
  env = environment;

  constructor(private router: Router, route: ActivatedRoute, private translateService: TranslateService) {
    const _self = this;
    ExcCoreModule.RegisterService('Router', this.router);
    ExcCoreModule.RegisterConfig('Environment', this.env);
    const env = ExcCoreModule.Config().Environment;
    const version = (env && env.version) ? env.version : '';
    const queryParam = (version !== '') ? '?v=' + version : '';
    if (queryParam !== '') {
      (translateService.currentLoader as TranslateHttpLoader).suffix = (translateService.currentLoader as TranslateHttpLoader).suffix + queryParam;
    }
    ExcCoreModule.RegisterService('TranslateService', this.translateService);

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => route),
      map((rte) => {
        while (rte.firstChild) {
          rte = rte.firstChild;
        }
        return rte;
      }),
      filter((rte) => rte.outlet === 'primary'),
      mergeMap((rte) => {
        return rte.data;
      }))
      .subscribe((event) => {
        ExcCoreModule.call('excTab.ChangeStateLabel', event.friendlyName);
      });
  }

}

